import { WatchQueryFetchPolicy } from '@apollo/client';

import { useLoggingQuery } from 'lib/apollo/apollo-hooks';
import {
  GET_LESSON_TEACHING_LEARNING_SEQUENCE,
  GET_ALL_DEFINED_TEACHING_AND_LEARNING_STRATEGIES,
} from './teaching-notes.graphql';
import { useSnackbar } from 'approot/shared/snackbar-notification/snackbar-notification.hooks';
import type {
  GetLessonTeachingAndLearningSequenceQuery,
  GetLessonTeachingAndLearningSequenceQueryVariables,
} from './teaching-notes.graphql.generated';
import type { GetAllDefinedTeachingAndLearningStrategiesQuery } from './teaching-notes.graphql.generated';

type GetSequencesProps = {
  contentId: number;
  classId?: number;
  version?: string | null;
  fetchPolicy?: WatchQueryFetchPolicy;
  skip?: boolean;
  authenticate?: boolean;
};

export const useGetLessonSequences = ({
  contentId,
  classId,
  fetchPolicy = 'cache-first',
  version,
  skip,
  authenticate = true,
}: GetSequencesProps) => {
  const { showError } = useSnackbar();

  const { data, loading, error } = useLoggingQuery<
    GetLessonTeachingAndLearningSequenceQuery,
    GetLessonTeachingAndLearningSequenceQueryVariables
  >(
    GET_LESSON_TEACHING_LEARNING_SEQUENCE,
    {
      variables: {
        input: {
          contentId,
          classId,
          isDraft: !version,
          version,
        },
      },
      fetchPolicy,
      skip,
      onError: () => showError('There was an error retrieving teaching notes'),
    },
    authenticate
  );
  const sequences = data?.getLessonTeachingAndLearningSequence || null;

  return {
    sequences,
    loading,
    error,
  };
};

export const useTeachingAndLearningStrategyData = (props?: {
  fetchPolicy?: WatchQueryFetchPolicy;
}) => {
  const { data, loading, error } = useLoggingQuery<
    GetAllDefinedTeachingAndLearningStrategiesQuery,
    null
  >(GET_ALL_DEFINED_TEACHING_AND_LEARNING_STRATEGIES, {
    fetchPolicy: props?.fetchPolicy || 'cache-first',
  });

  return {
    data: data?.getAllDefinedTeachingAndLearningStrategies,
    loading,
    error,
  };
};
